var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { isObject } from '../utils/is';
import { curry, dig } from '../utils/fn';
import { defaultSpacingTheme } from './spacing';
export var backgroundColor = curry(function (backgroundColorContextString, theme) { return ({
    backgroundColor: dig(backgroundColorContextString, theme.backgroundColor)
}); }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
);
export var borderColor = curry(function (borderColorContextString, theme) { return ({
    borderColor: dig(borderColorContextString, theme.borderColor)
}); }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
);
export var borderTopColor = curry(function (borderColorContextString, theme) { return ({
    borderTopColor: dig(borderColorContextString, theme.borderColor)
}); }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
);
export var borderLeftColor = curry(function (borderColorContextString, theme) { return ({
    borderLeftColor: dig(borderColorContextString, theme.borderColor)
}); }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
);
export var borderRightColor = curry(function (borderColorContextString, theme) { return ({
    borderRightColor: dig(borderColorContextString, theme.borderColor)
}); }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
);
export var borderBottomColor = curry(function (borderColorContextString, theme) { return ({
    borderBottomColor: dig(borderColorContextString, theme.borderColor)
}); }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
);
export var borderRadius = curry(function (radiusSize, theme) { return ({
    borderRadius: theme.size.border.radius[radiusSize]
}); });
export var boxShadow = curry(function (variant, theme) { return ({
    boxShadow: theme.depth.boxShadow[variant].xOffset + " " + theme.depth.boxShadow[variant].yOffset + " " + theme.depth.boxShadow[variant].blurRadius + " " + theme.depth.boxShadow[variant].spreadRadius + " " + theme.depth.boxShadow[variant].color
}); });
export var boxShadowFocus = function (borderColorContextString, theme, inset) {
    var colorOptions = dig(borderColorContextString, theme.borderColor);
    return {
        boxShadow: (inset ? 'inset ' : '') + "0 0 0 " + theme.size.border.focus + "px " + (colorOptions === null || colorOptions === void 0 ? void 0 : colorOptions.focus)
    };
};
export var fill = curry(function (colorContextString, theme) { return ({
    fill: dig(colorContextString, theme.font.color)
}); }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
);
export var fontFamily = curry(function (family, theme) { return ({
    fontFamily: theme.font[family].family
}); });
export var fontSize = curry(function (size, theme) { return ({
    fontSize: isObject(size)
        ? theme.font[size.context].size[size.size]
        : theme.font.base.size[size]
}); }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
);
export var fontWeight = curry(function (weight, theme) { return ({
    fontWeight: isObject(weight)
        ? theme.font[weight.context].weight[weight.weight]
        : theme.font.base.weight[weight]
}); });
export var color = curry(function (colorContextString, theme) { return ({
    color: dig(colorContextString, theme.font.color)
}); }
// eslint-disable-next-line @typescript-eslint/no-explicit-any
);
export var lineHeight = curry(function (lHeight, theme) { return ({
    lineHeight: theme.font.lineHeight[lHeight]
}); });
export var typography = curry(function (_a, theme) {
    var _b = _a === void 0 ? {} : _a, _c = _b.fontFamily, fFamily = _c === void 0 ? 'base' : _c, _d = _b.fontSize, fSize = _d === void 0 ? 'm' : _d, _e = _b.fontWeight, fWeight = _e === void 0 ? 'regular' : _e, _f = _b.lineHeight, lHeight = _f === void 0 ? 'base' : _f, _g = _b.color, colorContextString = _g === void 0 ? 'base' : _g;
    return (__assign(__assign(__assign(__assign({ fontFamily: theme.font[fFamily].family }, fontWeight(fWeight, theme)), fontSize(fSize, theme)), lineHeight(lHeight, theme)), color(colorContextString, theme)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    ));
});
// TODO: Handle compound values eg 2, 4 | 2, 3, 4 | 2, 3, 4, 5
var spacingAttributeFor = function (attribute) { return function (size) {
    var _a;
    if (size === void 0) { size = 7; }
    return (_a = {},
        _a[attribute] = defaultSpacingTheme[size],
        _a);
}; };
export var padding = spacingAttributeFor('padding');
export var paddingBottom = spacingAttributeFor('paddingBottom');
export var paddingLeft = spacingAttributeFor('paddingLeft');
export var paddingRight = spacingAttributeFor('paddingRight');
export var paddingTop = spacingAttributeFor('paddingTop');
export var margin = spacingAttributeFor('margin');
export var marginBottom = spacingAttributeFor('marginBottom');
export var marginLeft = spacingAttributeFor('marginLeft');
export var marginRight = spacingAttributeFor('marginRight');
export var marginTop = spacingAttributeFor('marginTop');
export var height = spacingAttributeFor('height');
export var minHeight = spacingAttributeFor('minHeight');
export var maxHeight = spacingAttributeFor('maxHeight');
export var width = spacingAttributeFor('width');
export var minWidth = spacingAttributeFor('minWidth');
export var maxWidth = spacingAttributeFor('maxWidth');
export var top = spacingAttributeFor('top');
export var bottom = spacingAttributeFor('bottom');
export var right = spacingAttributeFor('right');
export var left = spacingAttributeFor('left');
